<div
    class="bg-pattern pb-16 md:pb-20 aarni-font bg-cover bg-no-repeat bg-center h-fit md:h-[700px] lg:h-[650px] xl:h-[800px] mt-[80px]"
    style="background-image: url('assets/img/alumni-connect/alumni-connect-bg.webp')"
>
    <div class="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] mx-auto relative py-8">
        <div class="relative">
            <img
                [src]="slides[currentSlide].image"
                alt="Alumni Slide"
                class="w-full h-auto border-8 border-white relative z-10"
            />
            <div class="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2 z-20">
                <ng-container *ngFor="let slide of slides; let i = index">
                    <div
                        class="w-3 h-3 rounded-full border border-white cursor-pointer transition-all duration-300"
                        [ngClass]="{
              'bg-green-600': currentSlide === i,
              'bg-transparent': currentSlide !== i
            }"
                        (click)="goToSlide(i)"
                    ></div>
                </ng-container>
            </div>
        </div>
    </div>
</div>


<div class="relative -mt-16 md:-mt-60 lg:-mt-60 xl:-mt-56 z-10 aarni-font">
    <div class="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] mx-auto bg-white shadow-xl grid grid-cols-1 md:grid-cols-2">
        <div class="px-4 sm:px-6 py-6">
            <h2 class="text-blue-800 font-semibold text-3xl mb-2">
                Welcome to ARNI University
            </h2>
            <p class="text-gray-700 text-md">
                "Education is the passport to the future, for tomorrow belongs to those who prepare for it today." –
                Malcolm X
            </p>
            <p class="text-gray-700 text-md my-4">
                ARNI University has been a beacon of academic excellence and innovation. Located amidst the serene hills
                of Himachal Pradesh, ARNI is committed to nurturing talent and empowering students with the skills and
                values needed in today’s global landscape.
            </p>
            <p class="text-gray-700 text-md mb-4">
                Our alumni network stands as a testament to the quality of education we provide—spanning industries,
                nations, and communities, they are shaping a better future every day.
            </p>
            <a href="/about/about-us"><p class="text-blue-600 text-lg underline cursor-pointer text-right">
                Read More
            </p></a>
        </div>
        <a [href]="'/about/leadership/chancellor'" class="relative overflow-hidden cursor-pointer group">
            <img
                src="assets/img/top-leadership/chancellor-arni.jpg"
                alt="Chancellor Message"
                class="w-full h-auto max-h-[400px] object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <p class="absolute bottom-4 left-4 text-white font-semibold text-sm sm:text-base lg:text-lg bg-black/50 px-2 py-1 rounded">
                Chancellor's Message
            </p>
        </a>
    </div>
    <div
        class="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] mx-auto bg-gradient-to-r from-green-300 to-cyan-700 grid grid-cols-1 md:flex">
        <div class=" flex items-stretch md:basis-[40%]">
            <img
                src="assets/img/alumni-connect/alumni-newsroom-image.jpeg"
                alt="Newsroom Image"
                class="w-full h-full object-cover"
            />
        </div>
        <a [href]="'/quick-links/announcements'" class="flex flex-col justify-center md:basis-[60%] w-full h-full transition-transform duration-300 hover:scale-[1.02] overflow-hidden">
            <h3 class="text-white font-semibold text-2xl md:text-3xl p-2 my-4">Newsroom</h3>
            <ul class="space-y-4 text-white text-lg p-2 w-full">
                <li
                    *ngFor="let item of newsroomItems"
                    class="flex justify-between border-b border-white pb-2 last:border-b-0"
                >
                    <span class="w-[70%] text-lg md:text-xl">{{ item.title }}</span>
                    <span class="text-sm md:text-lg text-white w-[30%] text-right">{{ item.date }}</span>
                </li>
            </ul>
        </a>
    </div>
    <div
        class="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] mx-auto flex flex-col md:flex-row gap-0 bg-gradient-to-l from-green-400 to-cyan-600">
        <a [href]="'/campus-life/infrastructure'" class="md:basis-[30%] relative overflow-hidden cursor-pointer group block">
            <img
                src="assets/img/blog-images/img_1.webp"
                alt="ARNI University"
                class="w-full h-full object-cover rounded transition-transform duration-300 group-hover:scale-105"
            />
            <div
                class="absolute inset-0 flex items-center justify-center text-white text-4xl font-bold bg-black/40 rounded transition duration-300">
                Infrastructure
            </div>
        </a>
        <a [href]="['/quick-links/announcements']" class="block no-underline">
            <div class="md:basis-[40%] shadow-md p-4 max-h-[300px] cursor-pointer">
                <h3 class="text-white font-semibold text-2xl md:text-3xl mb-4">Jobs</h3>
                <ul class="space-y-3 text-white">
                    <li *ngFor="let job of jobs" class="flex justify-between items-start border-b pb-2 text-md">
                        <span class="w-[65%] font-medium">{{ job.title }}</span>
                        <span class="w-[35%] text-right">{{ job.time }}</span>
                    </li>
                </ul>
            </div>
        </a>
        <a [href]="'/quick-links/image-gallery'" class="md:basis-[30%] relative overflow-hidden cursor-pointer block group">
            <img
                src="assets/img/alumni-connect/alumni-connect-gallery-bg.JPG"
                alt="Gallery"
                class="w-full h-full object-cover rounded group-hover:brightness-75 transition-transform duration-300 group-hover:scale-105"
            />
            <div
                class="absolute inset-0 flex items-center justify-center text-white text-4xl font-bold bg-black/40 rounded transition duration-300">
                Gallery
            </div>
        </a>
    </div>
    <div class="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] mx-auto bg-gradient-to-l from-green-400 to-cyan-600">
        <div class="grid grid-cols-5 sm:grid-cols-10 gap-0">
            <div *ngFor="let image of squareImages; let i = index" class="aspect-square">
                <img
                    [src]="image"
                    alt="Square Image {{ i + 1 }}"
                    class="w-full h-full object-cover"
                />
            </div>
        </div>
    </div>
</div>

<div class="container mx-auto py-12">
    <h2 class="font-bold text-4xl md:text-5xl mb-4 text-center">
       Success Stories
    </h2>

    <div class="max-w-6xl mx-auto px-4">
        <div class="relative">
            <div class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4 h-full md:h-96">
                <div class="relative w-full md:w-1/3 h-64 md:h-auto">
                    <img [src]="stories[currentStorySlide].image"
                         [alt]="stories[currentStorySlide].name"
                         class="w-full h-full object-cover">
                    <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2 text-sm md:text-base font-semibold">
                        {{ stories[currentStorySlide].name }}
                    </div>
                </div>
                <div class="w-full md:w-2/3 p-6 overflow-y-auto">
                    <h2 class="text-lg md:text-xl font-bold text-gray-800 mb-1">{{ stories[currentStorySlide].qualification }}</h2>
                    <p class="text-sm text-gray-700 font-medium mb-1">{{ stories[currentStorySlide].position }}</p>
                    <p class="text-gray-700 text-justify text-md" [innerHTML]="stories[currentStorySlide].description"></p>
                </div>
            </div>
            <div class="absolute top-1/2 left-0 transform -translate-y-1/2 md:-ml-16 sm:-ml-8">
                <button (click)="prevSlide()" class="bg-gray-800 text-white p-2 lg:p-4 rounded-full shadow-md hover:bg-gray-700">
                    <i class="fa fa-arrow-left text-sm lg:text-lg"></i>
                </button>
            </div>
            <div class="absolute top-1/2 right-0 transform -translate-y-1/2 md:-mr-16 sm:-mr-8">
                <button (click)="nextSlide()" class="bg-gray-800 text-white p-2 lg:p-4 rounded-full shadow-md hover:bg-gray-700">
                    <i class="fa fa-arrow-right text-sm lg:text-lg"></i>
                </button>
            </div>
        </div>
    </div>
</div>
